module.exports = __webpack_public_path__ + "img/fs_06.19ce4543.jpg";